module.exports = __webpack_public_path__ + "media/images/icon__betPick--none-1aa50f5feda587b14caff2de254d4233.png";